// Library Methods
import { useMemo } from "react";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Constants
import { ExamSectionReportType } from "src/services/exams/types";

// Hooks
import useProgressionAnalysisColumns from "./hooks/useProgressionAnalysisColumns";
import usePatternChartColumns from "./hooks/usePatternChartColumns";

type ProgressionReportColumnsType = {
  examReport?: ExamSectionReportType;
};

const ProgressionReportColumns = ({
  examReport,
}: ProgressionReportColumnsType) => {
  const { progressionAnalysisColumns } = useProgressionAnalysisColumns();
  const { patternChartColumns } = usePatternChartColumns(examReport);

  const columns = useMemo(() => {
    if (!examReport) {
      return progressionAnalysisColumns;
    }
    return patternChartColumns;
  }, [examReport, patternChartColumns, progressionAnalysisColumns]);

  if (!examReport) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(3, 1fr)",
            },
            columnGap: "8px",
          }}
        >
          {columns.map((column) => (
            <Typography key={column.title} fontSize="13px">
              <span style={{ fontWeight: 600 }}>{column.title}:</span>{" "}
              <span
                style={{
                  color: Boolean(column.isBlueText) ? "#2563EB" : "#000",
                }}
              >
                {column.value}
              </span>
            </Typography>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
        },
        columnGap: "8px",
      }}
    >
      {columns.map((column) => (
        <Typography key={column.title} fontSize="14px">
          <span style={{ fontWeight: 600 }}>{column.title}:</span>{" "}
          <span
            style={{
              color: Boolean(column.isBlueText) ? "#2563EB" : "#000",
            }}
          >
            {column.value}
          </span>
        </Typography>
      ))}
    </Grid>
  );
};

export default ProgressionReportColumns;
